module.exports = __webpack_public_path__ + "img/seo-content-collapsible-chevy.554a11a8.png";